import {
  loginUser,
  LoginUser,
  logoutUser,
} from "@/api-client/api/services/loginService/loginService";
import {
  localStoragePaymentStatusShown,
  localStorageRegistrationSuccessEmail,
  localStorageRegistrationSuccessIsSmartId,
} from "./localStorage";

export async function login(data: LoginUser) {
  try {
    await loginUser(data);
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    }
    throw new Error("An unexpected error occurred.");
  }
}

export const logout = async (refreshUser: () => void) => {
  await logoutUser();
  localStorageRegistrationSuccessIsSmartId.removeItem();
  localStorageRegistrationSuccessEmail.removeItem();
  localStoragePaymentStatusShown.removeItem();
  await refreshUser();
};
